(function () {
  const loader = document.getElementById('et-page-loader');
  const root = document.documentElement;

  function releasePage() {
    root.classList.remove('et-home-loading');
  }

  if (!loader) {
    releasePage();
    return;
  }

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection?.saveData === true;

  if (prefersReducedMotion || saveData) {
    loader.remove();
    releasePage();
    return;
  }

  const MIN_VISIBLE_MS = 1200;
  const start = performance.now();
  let dismissed = false;

  function dismiss() {
    if (dismissed) return;
    dismissed = true;

    const elapsed = performance.now() - start;
    const wait = Math.max(0, MIN_VISIBLE_MS - elapsed);

    window.setTimeout(() => {
      loader.classList.add('is-hidden');
      releasePage();

      window.setTimeout(() => loader.remove(), 800);
    }, wait);
  }

  if (document.readyState === 'complete') {
    dismiss();
  } else {
    window.addEventListener('load', dismiss, { once: true });
  }

  window.setTimeout(dismiss, 2800);
})();
